// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PWGx","index":"styles_index__1KqKc"};